import "bootstrap-datepicker"

export function attachDatepicker($context) {
    $context.find(".date").datepicker({
        autoclose: true,
    });
}
